import { Directive, ElementRef, forwardRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { SubscriptionInfo } from '../../model';
import { AuthenticationService } from '../../service/authentication.service';
import { ContextService } from '../../service/context.service';
import { AbstractThingContextService } from '../class/abstract-thing-context-service.class';

@Directive({ selector: '[hasFeature]' })
export class HasFeatureDirective implements OnInit {

    @Input() hasFeature: string[];

    constructor(
        @Inject(forwardRef(() => ElementRef)) private el: ElementRef,
        @Inject(forwardRef(() => Renderer2)) private renderer: Renderer2,
        @Inject(forwardRef(() => AbstractThingContextService)) private thingContextService: AbstractThingContextService,
        @Inject(forwardRef(() => ContextService)) private contextService: ContextService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService
    ) { }

    ngOnInit(): void {
        if (this.hasFeature?.length && !this.hasFeatures(...this.hasFeature)) {
            const parent = this.el.nativeElement.parentNode;
            if (parent) {
                this.renderer.removeChild(parent, this.el.nativeElement);
            }
        }
    }

    private hasFeatures(...featureNames: string[]): boolean {
        if (this.authenticationService.isOrganizationUser()) {
            return true;
        }
        return featureNames.some(f => this.getSubscription()?.features?.includes(f));
    }

    private getSubscription(): SubscriptionInfo {
        if (this.thingContextService.getCurrentThing()) {
            return this.thingContextService.getSubscription();
        } else if (this.authenticationService.isPartnerUser()) {
            return this.authenticationService.getUser().partner?.subscriptionInfo;
        } else if (this.authenticationService.isCustomerUser()) {
            return this.authenticationService.getUser().customer?.subscriptionInfo;
        }
        const customerCtx = this.contextService.getCurrentCustomer();
        if (customerCtx) {
            return customerCtx.subscriptionInfo;
        }
        const partnerCtx = this.contextService.getCurrentPartner();
        if (partnerCtx) {
            return partnerCtx.subscriptionInfo;
        }
        return null;
    }
}